import React from 'react';
import styles from './Avatar.module.scss';

function getInitials(name: string) {
  if (!name) {
    return '';
  }

  const initials = (name.match(/[^\s-]+/g) || [])
    .map(segment => segment[0])
    .join('');
  return initials.length > 3
    ? `${initials[0]}${initials[initials.length - 1]}`
    : initials;
}

interface Props {
  name?: string;
  imageUrl?: string;
}

/* TODO: pass in prop to render profile picture if they have it */
const Avatar = ({ name = '', imageUrl }: Props) => (
  <div className={styles.avatarContainer} style={imageUrl ? { backgroundImage: `url("${imageUrl}")` } : undefined}>
    <div className={styles.avatar}>
      {imageUrl ? null : <span>{getInitials(name)}</span>}
    </div>
  </div>
);

export default Avatar;
